// Welke vragen mag deze vraag als trigger gebruiken?
//
// ALLEEN VRAGEN DIE EERDER STAAN. Daarmee is een kringverwijzing (A hangt van
// B, B hangt van A) per constructie onmogelijk — er is geen graafvalidatie
// nodig, en de respondent heeft de trigger altijd al gezien voordat de
// afhankelijke vraag aan de beurt is.
//
// SECTIEKOPPEN VALLEN AF: een sectie heeft geen antwoord om op te matchen. Een
// sectie mag wél zelf een regel dragen (dan verdwijnt de hele pagina), dus als
// doel is hij geldig — alleen niet als bron.
//
// MEETSTANDAARDVRAGEN VALLEN AAN BEIDE KANTEN AF. Als doel: een MSI-effect
// wordt afgemeten aan het verschil tussen voor- en nameting, dus die vraag moet
// altijd gesteld worden. Als bron: dat zou technisch kunnen, maar het scheelt
// een uitzonderingsregel om aan gebruikers uit te leggen.
//
// KWALIFICERINGSVRAGEN OOK: verplicht en altijd gesteld, en beheerd door de
// schakelaar op het onderzoek. Een regel erop of ervan zou dat stil ondermijnen.
// AI-CONTEXT: See docs/features/conditional-questions.md
// AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md

import flattenFieldsInOrder from './flattenFieldsInOrder'
import isStandardQuestion from './isStandardQuestion'
import isQualifyingQuestion from './isQualifyingQuestion'

/**
 * @param {Array<object>} fields - Alle QuestionnaireFields van de vragenlijst
 * @param {object} field - Het veld dat een regel zou krijgen
 * @returns {Array<object>} De bruikbare triggervragen, in weergavevolgorde.
 *   Leeg als het veld zelf geen regel mag hebben of niet in de lijst staat.
 */
const eligibleTriggerFields = (fields, field) => {
    if (!Array.isArray(fields) || !field?.ID) return []
    if (isStandardQuestion(field) || isQualifyingQuestion(field)) return []

    const ordered = flattenFieldsInOrder(fields)
    const index = ordered.findIndex((item) => item?.ID === field.ID)
    if (index < 0) return []

    return ordered
        .slice(0, index)
        .filter((item) => item?.Type !== 'section' && !isStandardQuestion(item) && !isQualifyingQuestion(item))
}

export default eligibleTriggerFields
